// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","activeColor":"#7cf4fe","hoverColor":"#ffffff","uiBlack":"#000000","screen-sm":"1024px"};